<template>
  <div class="box">
    <md-button :loading="loading1" @click="clickButton1">按钮1</md-button>
    <md-button :loading="loading2" @click="clickButton2">按钮2</md-button>
  </div>
</template>
<script>
export default {
  data(){
    return{
      loading1: false,
      loading2: false,
    }
  },
  methods: {
    clickButton1(){
      this.loading1 = true
    },
    clickButton2(){
      this.loading2 = true
    }
  }
}
</script>
<style lang="less">
.box {
  display: flex;
  flex-direction: column;
}
</style>